import React from 'react';
import classNames from 'classnames';

import AccountCircle from '@material-ui/icons/AccountCircle';
import Paper from '@material-ui/core/Paper';
import {
  Typography, createStyles, withStyles, WithStyles,
} from '@material-ui/core';
import moment from 'moment';

import { parsePhoneNumber } from '../../../helpers/reserveHelpers';
import UserStatisticTableItem from '../../Common/Statistic/StatisticTable/UserStatisticTableItem.tsx';
import { UserLoyaltyInfo } from "../../../_FSD/shared/ui/userLoyaltyInfo";
import _ from "lodash";

interface Props {
  userInfo: {
    firstVisit: string;
    lastVisit: string;
    isActive: boolean;
    name: string;
    phone: string;
    groupName?: string;
    balance?: number;
  };
  statistic: {
    averageReceiptAmount: number;
    total: number;
    totalCancelledByGuest: number;
    totalCancelledByRestaurant: number;
    totalClosed: number;
    totalDeclined: number;
    totalReceiptAmount: number;
  };
  moneySymbol: string;
}

const styles = () => createStyles({
  wrap: {
    height: '100%',
    minHeight: 302,
  },
  roleWrap: {
    padding: '24px 24px 35px 24px',
    display: 'flex',
  },
  roleTitle: {
    backgroundColor: '#f7f8fb',
    padding: '0px 24px',
    height: 24,
    display: 'flex',
    alignItems: 'center',
  },
  activityDateWrap: {
    paddingTop: 12,
  },
  infoWrap: {
    display: 'flex',
    padding: '0 24px',
  },
  userInfoWrap: {
    marginTop: 20,
    display: 'flex',
    flexDirection: 'column',
  },
  statusWrap: {
    padding: '4px 8px',
    textTransform: 'uppercase',
    backgroundColor: 'rgb(106, 233, 197, 0.3)',
    color: 'black',
  },
  statusWrap__deactivated: {
    backgroundColor: 'rgb(244, 88, 88, 0.3)',
  },
  userIcon: {
    width: 77,
    height: 77,
    marginRight: 14,
  },
  userStatWrap: {
    display: 'flex',
    padding: '35px 24px',
    '&:last-child': {
      paddingTop: 0,
    }
  },
});

interface IProps extends Props, WithStyles<typeof styles> {}

// userInfo && userInfo.isActive ? 'primary' : 'error'

const index: React.FC<IProps> = ({ userInfo, classes, statistic, moneySymbol }) => {
  const firstVisit = userInfo.firstVisit ? moment(userInfo.firstVisit).format('DD MMMM YYYY г.') : '—';
  const lastVisit = userInfo.lastVisit ? moment(userInfo.lastVisit).format('DD MMMM YYYY г.') : '—';

  const isActive = userInfo.isActive ? (
    <Typography className={classes.statusWrap} variant="overline">
      Активный
    </Typography>
  ) : (
    <Typography className={classNames(classes.statusWrap, classes.statusWrap__deactivated)} variant="overline">
      Не активный
    </Typography>
  );

  return (
    <Paper elevation={3} className={classes.wrap}>
      <div>
        <div className={classes.roleWrap}>
          <div className={classes.roleTitle}>
            <Typography variant="body1">
              ГОСТЬ
            </Typography>
          </div>
        </div>
        <div className={classes.infoWrap}>
          <AccountCircle
            color="secondary"
            className={classes.userIcon}
          />
          <div>
            <Typography variant="h4">
              {userInfo ? userInfo.name : '—'}
            </Typography>
            <Typography variant="body1">
              {userInfo ? parsePhoneNumber(userInfo.phone) : '—'}
            </Typography>
            <div className={classes.userInfoWrap}>
              <div>
                {isActive}
              </div>
              <div className={classes.activityDateWrap}>
                <Typography variant="body2">
                  {`Дата создания: ${firstVisit}`}
                </Typography>
                <Typography variant="body2">
                  {`Последний резерв: ${lastVisit}`}
                </Typography>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.userStatWrap}>
          <UserStatisticTableItem
            type="Средний чек"
            stat={`${statistic.averageReceiptAmount.toFixed()} ${moneySymbol}`}
            color="primary"
            textAlign="center"
          />
          <UserStatisticTableItem
            type="Посещений"
            stat={`${statistic.total.toFixed()}`}
            textAlign="center"
          />
          <UserStatisticTableItem
            type="Всего потрачено"
            stat={`${statistic.totalReceiptAmount.toFixed()} ${moneySymbol}`}
            textAlign="center"
          />
        </div>
        {Boolean(userInfo.groupName) && !Boolean(_.isNil(userInfo.balance)) && <div className={classes.userStatWrap}>
          <UserLoyaltyInfo bonus={userInfo.balance} type={userInfo.groupName} />
        </div>}
      </div>
    </Paper>);
};

export default withStyles(styles)(index);
